/**
 * Grid Stores Manager - Moon Moon Agency
 * Filtre les boutiques par continent dans la section MM-Grid-Stores.
 */

/*********************************************************************************************
 * 🏬 GRID STORES MANAGER
 */
const GridStoresManager = {
	config: {
		selectors: {
			filter: '.mm-grid-stores__filter',
			item: '.mm-grid-stores__item',
		},
		classes: {
			active: 'mm-grid-stores__filter--active',
			hidden: 'mm-grid-stores__item--hidden',
		},
	},

	init() {
		const filters = window.getElements(this.config.selectors.filter);
		if (!filters.length) return; // Guard clause : pas de filtres dans le DOM

		this._bindEvents();
		window.log('info', '🏬 [GRID_STORES]', 'Initialized');
	},

	_bindEvents() {
		document.addEventListener('click', (e) => {
			const filter = e.target.closest(this.config.selectors.filter);
			if (!filter) return;
			this.apply(filter);
		});
	},

	apply(filter) {
		const value = filter.dataset.filter;

		// État actif des filtres
		window.getElements(this.config.selectors.filter).forEach((el) => {
			const isActive = el === filter;
			el.classList.toggle(this.config.classes.active, isActive);
			el.setAttribute('aria-pressed', String(isActive));
		});

		// Affichage des cartes
		window.getElements(this.config.selectors.item).forEach((item) => {
			const match = value === 'all' || item.dataset.continent === value;
			item.classList.toggle(this.config.classes.hidden, !match);
		});

		window.log('info', '🏬 [GRID_STORES]', 'Filtered', { continent: value });
	},
};

if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', () => GridStoresManager.init());
} else {
	GridStoresManager.init();
}
